import { Badge } from '@mantine/core';
import { ContractType } from '../../../api/contracts';

interface ContractTypeBadgeProps {
  type: ContractType;
}

export function ContractTypeBadge({ type }: ContractTypeBadgeProps) {
  const labelMap = {
    SUPPLY_OF_ITEMS: 'Supply of Items',
    SUPPLY_AND_INSTALLATION: 'Supply & Installation',
    WORKS: 'Works',
  };

  const colorMap = {
    SUPPLY_OF_ITEMS: 'blue',
    SUPPLY_AND_INSTALLATION: 'purple',
    WORKS: 'orange',
  };

  return (
    <Badge color={colorMap[type]} variant="light">
      {labelMap[type]}
    </Badge>
  );
}

